import {get, isEmpty, isNil} from 'lodash'

export const PartScalingType = {
  VARIABLE: {
    id: 1,
    label: 'Variable (add one per line item)',
  },
  FIXED: {
    id: 2,
    label: 'Fixed (add one per part)',
  },
}

export const PartMultipleType = {
  MULTIPLE: {
    id: 2,
    label: 'Multiple (allow any)',
  },
  SINGULAR: {
    id: 1,
    label: 'Singular (allow one only)',
  },
}

export const nullPricingTemplateItem = {
  scalingType: PartScalingType.VARIABLE.id,
  name: null,
  multiple: false,
  id: -1,
  templateId: -1,
  mandatory: false,
  partCategoryId: null,
  category: {
    id: null,
    name: null,
  },
  order: 0,
  guid: null,
}

export const getPartMultipleTypeValue = (multiple) => {
  return multiple ? PartMultipleType.MULTIPLE.id : PartMultipleType.SINGULAR.id
}

export const convertPartMultipleTypeValue = (multiple) => {
  return multiple ===  PartMultipleType.MULTIPLE.id
}

export const isPricingTemplateItemsEmpty = (pricingTemplate) => {
  const pricingTemplateItems = get(pricingTemplate, 'items', [])
  return isNil(pricingTemplateItems) || isEmpty(pricingTemplateItems)
}